(function () {
	'use strict';

	angular.module('qbePortal').controller('QBListAggregatorController', 'quoteModelFactory', QBListAggregatorController);
	QBListAggregatorController.$inject = ['$scope', 'Util', 'quoteModelFactory'];

	function QBListAggregatorController($scope, Util, quoteModelFactory) {
		var vm = this;
		var _aggregatorPrefix = "agg_";

		vm.$onInit = function () {
			vm.items = vm.list || [];
			vm.quoteModel = quoteModelFactory.create();

			/**
			 * to make this compatible with data coming from rapid-estimate or retrieve quote.
			 */
			vm.items.forEach(function (element, index) {
				if (!element._aggregator) {
					var name = (index == 0 && vm.defaultValue) ? vm.defaultValue._aggregator.name : 'additional';
					var id = _aggregatorPrefix + index;
					element._aggregator = {
						id: id,
						name: name,
						title: (index == 0 && vm.defaultValue) ? vm.defaultValue._aggregator.title : 'additional',
					};
					element._HTMLID = name + id;
					setFullHeadingForItem(element);
				}
				$scope.$emit('show-aggregate');
			})

			if (vm.items.length == 0 && vm.defaultValue) {
				var item = vm.defaultValue;
				item._HTMLID = item._aggregator.name + item._aggregator.id;
				setFullHeadingForItem(item);
				vm.items.push(item);
				updateParentSection();
			}

			vm.addItem = function (id, item) {
				id = id || vm.items.length;
				id = _aggregatorPrefix + id;
				item = Util.deepClone(item);
				item._aggregator.id = id;
				item._HTMLID = item._aggregator.name + item._aggregator.id;

				setFullHeadingForItem(item);

				vm.items.push(item);
				updateParentSection();
			}
		}

		function setFullHeadingForItem(item) {
			if (item._aggregator.id > 0) {
				item._aggregator.fullHeading = item._aggregator.title + ' ' + vm.typeName + ' ' + item._aggregator.id;
			} else {
				item._aggregator.fullHeading = item._aggregator.title + ' ' + vm.typeName;
			}
		}

		function updateParentSection() {
			vm.update({
				name: vm.name,
				value: vm.items
			});
		}
	}

	angular.module('qbePortal').component('qbListAggregator', {
		templateUrl: '../ngviews/components/qbListAggregator.html',
		controller: QBListAggregatorController,
		controllerAs: 'vm',
		bindings: {
			list: '<',
			name: '@',
			item: '<',
			defaultValue: '<',
			typeName: '@',
			update: '&',
			max: '<'
		}
	});
})();
